import { fetchAPI } from "../components/service/Encrtyption";

export const submitGenuityCheck = async (payload, { appLangCode, customerId, mobileNumber } = {}) => {
  const responseData = await fetchAPI(
    process.env.REACT_APP_API_URL_SCAN,
    payload,
    {
      customerid: customerId || payload.customerId || "",
      mobileNumber: mobileNumber || payload.mobileNumber || "",
      userAuthorizationToken: "",
      deviceid: "WEB",
      appLangCode: appLangCode || payload.appLangCode || "hi",
    }
  );

  return JSON.parse(responseData);
};
